import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card, Row, Col } from "react-bootstrap";
import { IB2bAgentDocument } from ".";

interface Iprops {
  documents: IB2bAgentDocument[];
}

export default function CompanyDocuments(props: Iprops) {
  return (
    <Card className="mt-lg-4 mt-3 p-3 p-md-4" id="documents">
      <h5 className="fw-bold">Documents</h5>
      <Row>
        {props.documents && props.documents.length > 0 ? (
          props.documents.map((doc) =>
            doc.url ? (
              <Col
                className="col-12 col-sm-6 col-lg-4 mt-3 mt-sm-3"
                key={doc.name}
              >
                <a
                  className="text-decoration-none align-items-center d-flex p-3 bg-opacity-25 bg-info rounded"
                  href={doc.url}
                  target="_blank"
                  rel="noreferrer"
                >
                  <span>{doc.name}</span>
                  <FontAwesomeIcon
                    icon={faFilePdf}
                    className="fs-3 mx-2"
                    color="red"
                  />
                </a>
              </Col>
            ) : null
          )
        ) : (
          <Col>
            <span>No documents found.</span>
          </Col>
        )}
      </Row>
    </Card>
  );
}
